import { Component, ViewChild, OnInit, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DropzoneAttach2Component } from '../dropzone/dropzone-attach2.component';
import { SharedService } from '../shared/shared.service';
import { ProjectDataService } from '../shared/dataservice.service';
import { ProjectsService } from '../projects/projects.service';
import { ProjectsInfoService } from './projectinfo.service';
import * as Materialize from 'angular2-materialize/dist/index';
import * as globals from '../globals';
import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';
import { UploadService } from '../shared/upload.service';
import { UtilsService } from '../shared/utils.service';
import { S3CredService } from '../shared/s3-cred-service';
import { NavbarService } from '../navbar/navbar.service';
import { GetFileTypeService } from '../shared/getFileType/get-file-type.service';
import { BackButtonComponent } from '../shared/inAppBack/back-button/back-button.component';

declare var openNewBrowserWindow: any;
declare let AWS: any;
declare var xml2json: any;
declare var json2xml: any;
declare var X2JS: any;

@Component({
  selector: 'app-projectinfo',
  templateUrl: 'projectinfo.component.html',
  styleUrls: ['projectinfo.component.css'],
  providers: [ProjectsService, ProjectsInfoService, S3CredService, GetFileTypeService]
})
export class ProjectinfoComponent implements OnInit {

  project: any = {};
  recipe: any = {};
  tenanturl: string = '';
  tenantid: string = '';
  planid: string;
  attchTabOn = false;
  _service: any;
  errorMessage: string;
  loadingprojectsattachments: boolean = true;
  projectattachmentsempty: boolean = true;
  projectattachmentsloaderror: boolean = false;
  listOfObjectInBucket: any = [];
  s3FolderData = [];
  breadcrumbData = [];
  deletekey: string = '';
  delType: string = '';
  deletefolderbool: boolean = false;
  removingAttachment: string = '';
  _projectDataService: any;

  ownerselect: number;
  customerselect: number;
  statusselect: number;
  ownerArray: any = [];
  ownerDict: any = {};
  customerArray: any = [];
  customerDict: any = {};
  statusArray: any = [];
  statusDict: any = {};
  filledstar: number;
  halfstar: number;
  emptystar: number;
  public dateFormat: string;
  public currencySymbol: string;
  public currencyName: string;
  projectid: any;

  public max: number = 200;
  public currentValue: number;
  public type: string;
  public progresses: any = [];
  private bucketname = globals.BUCKETNAME;
  modalAttachmentUploadAction = new EventEmitter<string | MaterializeAction>();
  removeAttachmentfileAction = new EventEmitter<string | MaterializeAction>();

  @ViewChild(DropzoneAttach2Component) _dropzoneAttach2: DropzoneAttach2Component;
  constructor(private router: Router,
              private route: ActivatedRoute,
              private projectsService: ProjectsService,
              private service: SharedService,
              private projectDataService: ProjectDataService,
              private _ProjectsInfoService: ProjectsInfoService,
              private utilsService: UtilsService,
              private getFileTypeService: GetFileTypeService,
              private uploadService: UploadService,
              private s3CredService: S3CredService,
              public navService: NavbarService) {
    this._service = service;
    this._projectDataService = projectDataService;

    console.log('SERVICE:', service);
  }

  ngOnInit() {
    this.navService.show('PROJECT INFORMATION');
    this.navService.setNavID(-1);
    this.planid = localStorage.getItem('mr_planid');
    this.dateFormat = localStorage.getItem('mr_date_format_id');
    this.currencySymbol = localStorage.getItem('mr_currency_symbol');
    this.currencyName = localStorage.getItem('mr_currency_id');

    this.projectid = +this.route.snapshot.paramMap.get('id');
    console.log('project id: ', this.projectid);
    console.log('PLANID:', this.planid);

    if (typeof this.planid === 'undefined' || this.planid === '') {
      this.planid = '1';
    }

    if (this.planid === '3') {
      this.tenanturl = globals.GOVTENANTURL;
    } else {
      this.tenanturl = globals.TENANTURL;
    }

    this.tenantid = localStorage.getItem('mr_tenantid');

    this.service.getCorporateInfo().subscribe(
      data => {
        let jdata = JSON.parse(data);
        this.customerArray = jdata.customers;
        this.ownerArray = jdata.owners;

        console.log('customerArray: ', this.customerArray);

        this.listOfObjectInBucket = [];
        this.service.getProjectDetailsById(this.projectid).subscribe(
          data => {
            let parseddata = JSON.parse(data);
            console.log('PARSEDDATA:', parseddata);
            this.project = parseddata.project;
            this.recipe = parseddata.recipe;
            this.statusArray = parseddata.statuses;
            let filenamenoext = this.project.filename.replace(/\.[^/.]+$/, '');
            if (!filenamenoext) {
              filenamenoext = ' ';
            }
            this.project.filenamenoext = filenamenoext;

            // Determine the Model Type to show - based on the file extension
            this.project.modeltype = this.utilsService.getModelName(this.project.modeltype_id);

            if (this.project.modeltype != 0) {
              this.project.thumbnail = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + this.project.id + '/' + filenamenoext + '_320x240.png';
            } else {
              let ext = this.project.extension.toLowerCase();
              console.log('EXTENSION:', ext);
              this.project.thumbnail = this.getFileTypeService.returnFileTypeExtensionURLAppend96(ext);
            }

            for (let i = 0; i < this.ownerArray.length; i++) {
              this.ownerDict[this.ownerArray[i].id] = this.ownerArray[i].email;
            }

            for (let i = 0; i < this.customerArray.length; i++) {
              this.customerDict[this.customerArray[i].id] = this.customerArray[i].name;
            }

            for (let i = 0; i < this.statusArray.length; i++) {
              this.statusDict[this.statusArray[i].id] = this.statusArray[i].name;
            }

            this.calculateStarRating(this.recipe.rating);

            this._ProjectsInfoService.getProjectAttachments(this.tenantid, this.tenanturl, this.project.id, 'Attachments', true, 1).subscribe(
              data => {
                console.log('Got attachments');
                let x2js = new X2JS();
                let objectListForProjectID = x2js.xml_str2json(data);
                if (objectListForProjectID.ListBucketResult.Contents) {
                  if (objectListForProjectID.ListBucketResult.Contents instanceof Array) {
                    this.listOfObjectInBucket = objectListForProjectID.ListBucketResult.Contents;
                  } else {
                    this.listOfObjectInBucket[0] = objectListForProjectID.ListBucketResult.Contents;
                  }
                  let maps3objArray = this._ProjectsInfoService.parseAttachmentDataToFolder(this.listOfObjectInBucket);
                  let CurrentLevelObj = this._ProjectsInfoService.refreshLevelData(maps3objArray, 1, 'Attachments');
                  this.s3FolderData = CurrentLevelObj;
                  this.breadcrumbData = [];
                  this.breadcrumbData = this._ProjectsInfoService.getSplittedBreadcrumbDict('Attachments', 1);
                  // Start a timer to refresh the page when translation is complete
                  this.loadingprojectsattachments = false;
                  this.projectattachmentsempty = false;
                  this.projectattachmentsloaderror = false;
                } else {
                  this.errorMessage = ' Attachments folder is empty!';
                  console.error('getProjects() error:', this.errorMessage);
                  this.loadingprojectsattachments = false;
                  this.projectattachmentsempty = true;
                  this.projectattachmentsloaderror = true;
                }
              },
              error => {
                this.errorMessage = <any>error;
                console.error('getProjects() error:', this.errorMessage);
                this.loadingprojectsattachments = false;
                this.projectattachmentsempty = false;
                this.projectattachmentsloaderror = true;
              });
          },
          error => {
            this.errorMessage = <any>error;
            console.error('getProjects() error:', this.errorMessage);
          }
        );
      },
      error => {
        console.log('Error getting Corporate Info: ', error);
      }
    );

  }

  ngOnDestroy() {
    this.modalAttachmentUploadAction.emit({ action: 'modal', params: ['close'] });
    this.removeAttachmentfileAction.emit({ action: 'modal', params: ['close'] });
  }

  fileAddedToDropzone(event) {
    console.log(' file added to dropzone : ' + event);
  }

  changeAttachmentDirectory(foldername: string, FolderClicked: boolean, bcoccurant: number) {
    this.breadcrumbData = [];
    this.loadingprojectsattachments = true;
    this.s3FolderData = [];
    this.listOfObjectInBucket = [];
    let breadCrumbKeyString = this._ProjectsInfoService.getbreadCrumbinfo();
    let CurrentBreadcrumbPath = this._ProjectsInfoService.getCurrentBreadcrumbPath();
    if (FolderClicked) {
      bcoccurant = (CurrentBreadcrumbPath.match(new RegExp('/' + foldername, 'g')) || []).length;
      bcoccurant++;
    }
    if (!FolderClicked) {
      this.breadcrumbData = [];
      this.breadcrumbData = this._ProjectsInfoService.getSplittedBreadcrumbDict(foldername, bcoccurant);
      let count = 0;
      for (let i = 0; i <= bcoccurant; i++) {
        if (this.breadcrumbData[i] == foldername) {
          count++;
        }
      }
      bcoccurant = count;
    }
    this._ProjectsInfoService.getProjectAttachments(this.tenantid, this.tenanturl, this.project.id, foldername, FolderClicked, bcoccurant).subscribe(
      data => {
        let x2js = new X2JS();
        let objectListForProjectID = x2js.xml_str2json(data);
        if (objectListForProjectID.ListBucketResult.Contents) {
          if (objectListForProjectID.ListBucketResult.Contents instanceof Array) {
            this.listOfObjectInBucket = objectListForProjectID.ListBucketResult.Contents;
          } else {
            this.listOfObjectInBucket[0] = objectListForProjectID.ListBucketResult.Contents;
          }
          let maps3objArray = this._ProjectsInfoService.parseAttachmentDataToFolder(this.listOfObjectInBucket);
          let CurrentLevelObj = this._ProjectsInfoService.refreshLevelData(maps3objArray, 1, foldername);
          this.s3FolderData = CurrentLevelObj;
          this.breadcrumbData = [];
          this.breadcrumbData = this._ProjectsInfoService.getSplittedBreadcrumbDict(foldername, bcoccurant);
          // Start a timer to refresh the page when translation is complete

          // Start a timer to refresh the page when translation is complete
          this.loadingprojectsattachments = false;
          this.projectattachmentsempty = false;
          this.projectattachmentsloaderror = false;
        } else {
          this.errorMessage = ' Attachments folder is empty!';
          console.error('getProjects() error:', this.errorMessage);
          this.loadingprojectsattachments = false;
          this.projectattachmentsempty = true;
          this.projectattachmentsloaderror = true;
        }
      },
      error => {
        this.errorMessage = <any>error;
        console.error('getProjects() error:', this.errorMessage);
        Materialize.toast('Error occured while refreshing list', 2000);
        this.loadingprojectsattachments = false;
        this.projectattachmentsempty = false;
        this.projectattachmentsloaderror = true;
      });
  }

  onBack() {
    this.router.navigate(['/projects']);
  }

  openmodalAttachmentUpload() {
    this.modalAttachmentUploadAction.emit({ action: 'modal', params: ['open'] });
  }

  onOwnerChange(value) {
    console.log('owner value', value);
    this.ownerselect = value;
  }

  onCustomerChange(value) {
    console.log('customer value', value);
    this.customerselect = value;
  }

  onStatusChange(value) {
    console.log('Status value', value);
    this.statusselect = value;
  }



  projectInfoHeaderClicked(projectId: number) {

    console.log('projectInfoHeaderClicked');

    if (document.getElementById(projectId + 'projectInfoCollapsibleBody').className == 'active') {
      document.getElementById(projectId + 'projectInfoArrowRight').style.display = 'none';
      document.getElementById(projectId + 'projectInfoArrowDown').style.display = 'block';
      document.getElementById(projectId + 'projectInfoEdit').style.display = 'none';

    } else {
      document.getElementById(projectId + 'projectInfoArrowRight').style.display = 'block';
      document.getElementById(projectId + 'projectInfoArrowDown').style.display = 'none';
      document.getElementById(projectId + 'projectInfoEdit').style.display = 'block';
    }

  }

  partInfoHeaderClicked(projectId: number) {

    console.log('partInfoHeaderClicked');

    if (document.getElementById(projectId + 'partInfoCollapsibleBody').className != 'active') {
      document.getElementById(projectId + 'partInfoArrowRight').style.display = 'block';
      document.getElementById(projectId + 'partInfoArrowDown').style.display = 'none';

    } else {
      document.getElementById(projectId + 'partInfoArrowRight').style.display = 'none';
      document.getElementById(projectId + 'partInfoArrowDown').style.display = 'block';
    }

  }


  openInViewer(id: string, name: string) {
    // Build the URL
    let hwfurl = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + id + '/' + name + '.hwf';
    console.log('openInViewer() URL: ', hwfurl);
    localStorage.setItem('hwfurl', hwfurl);
    // this.router.navigate(['/viewer']);
    openNewBrowserWindow('/#/viewer', hwfurl);
  }

  OpenPDFView(project) {
    let PDFurl = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + project.id + '/' + project.name + '.pdf';

    var myNewTab = window.open();

    this.projectsService.downloadPDF(PDFurl).subscribe(
      (res) => {
        let fileURL = URL.createObjectURL(res);
        myNewTab.location.href = fileURL;
        // window.open(fileURL);
      }
    );
  }

  allowDrop(event) {
    console.log('Drag over called : event = ' + event + ' this.attchTabOn : ' + this.attchTabOn);
    if (this.attchTabOn) {
      this.openmodalAttachmentUpload();
    }
  }

  attachmentUpload() {
    console.log('File attachment : ', this._service.getFileArrayofAttchments());
    let filedata = this._service.getFileArrayofAttchments().slice();
    if (filedata.length) {
      (<HTMLInputElement>document.getElementById('uploadAttachmentButton')).disabled = true;
    }
    // filedata[0] has to be attached
    this.s3CredService.getProjectS3Creds(this.project.id)
      .subscribe(
      data => {
        let s3credentials = JSON.parse(data);
        let policy = s3credentials.s3creds.s3Policy;
        let signature = s3credentials.s3creds.s3Signature;
        let serverdate = s3credentials.s3creds.serverDate;
        let breadCrumbStringPath = this._ProjectsInfoService.getCurrentBreadcrumbPath();
        console.log('policy:', policy);
        console.log('signature:', signature);
        console.log('serverdate:', serverdate);
        this.ClearDropzoneAttach2();

        let fileuploadedCount = 0;
        let progressCount = 0;
        for (let uploadfilecount = 0; uploadfilecount < filedata.length; uploadfilecount++) {
          let filepath = filedata[uploadfilecount].fullPath;
          console.log('File path : ', filepath);

          // check for files which has only extensions and names is mising
          let splitname = filedata[uploadfilecount].name.split('.');
          if (!splitname[0]) {
            continue;
          }
          if (!filedata[uploadfilecount].name.includes('.')) {
            continue;
          }
          this.progresses.push({ id: progressCount, currentValue: 1, name: filedata[uploadfilecount].name });

          // Upload the file to the newly created project bucket/folder
          this.uploadService.makeFileRequest(this.tenanturl, [filepath, uploadfilecount, progressCount], filedata, this.project.id, breadCrumbStringPath, this.tenantid, this.planid, policy, signature, serverdate).then((result) => {
            console.log('Uploaded file. Result:', result);
            let breadCrumbStringPath = this._ProjectsInfoService.getCurrentBreadcrumbPath();
            let filesplit = breadCrumbStringPath.split('/');
            let uploadedBreadFolder;
            for (let i = 0; i < filesplit.length; i++) {
              uploadedBreadFolder = filesplit[i];
            }
            fileuploadedCount++;

            if (filedata.length == 1) {
              Materialize.toast(fileuploadedCount + ' file was uploaded.', 3000);
              this.progresses.pop();
              this.modalAttachmentUploadAction.emit({ action: 'modal', params: ['close'] });
              (<HTMLInputElement>document.getElementById('uploadAttachmentButton')).disabled = false;
              this.changeAttachmentDirectory(uploadedBreadFolder, false, 1);
              progressCount = 0;
            } else if (fileuploadedCount == progressCount) {
              Materialize.toast(fileuploadedCount + ' files were uploaded.', 3000);
              this.progresses = [];
              this.modalAttachmentUploadAction.emit({ action: 'modal', params: ['close'] });
              (<HTMLInputElement>document.getElementById('uploadAttachmentButton')).disabled = false;
              this.changeAttachmentDirectory(uploadedBreadFolder, false, 1);
              progressCount = 0;
            }
          });
          progressCount++;
        }

        this.uploadService.progress$.subscribe(
          data => {
            console.log('upload progress = ' + data);
            let values = data.split('~');
            this.progresses[values[1]].currentValue = values[0];
            // document.getElementById('progress' + values[1] ).style.width =  Number(values[0]) + '%';
          });

      },
      error => {
        this.errorMessage = <any>error;
        Materialize.toast('Uploading file failed: server error', 2000);
        console.error('checkProcessingStatus() error:', this.errorMessage);
      });
  }

  ClearDropzoneAttach2() {
    this._dropzoneAttach2.clearDropzoneAttach();

  }

  DeleteAttachmentFile(filename: string, isFolder: boolean) {
    this.deletekey = filename;
    this.deletefolderbool = isFolder;
    if (isFolder) {
      this.delType = 'folder';
    } else {
      this.delType = 'file';
    }
    this.removeAttachmentfileAction.emit({ action: 'modal', params: ['open'] });
  }

  cancelAttachmentDelete() {
    this.deletekey = '';
    this.deletefolderbool = false;
    this.delType = '';
  }

  confirmAttachementDelete() {
    if (!this.deletefolderbool) {
      this._ProjectsInfoService.DeleteProjectAttachmentFile(this.tenanturl, this.deletekey, false, null)
        .subscribe(
        data => {
          Materialize.toast('1 file was removed', 3000);
          let breadcrumbString = this._ProjectsInfoService.getCurrentBreadcrumbPath();
          let bcarray = breadcrumbString.split('/');
          let currentFolder = 'Attachments';
          for (let i = 0; i < bcarray.length; i++) {
            currentFolder = bcarray[i];
          }
          this.changeAttachmentDirectory(currentFolder, false, 1);
        },
        error => {
        });
    } else if (this.deletefolderbool) {
      this.listOfObjectInBucket = [];
      this._ProjectsInfoService.getProjectAttachments(this.tenantid, this.tenanturl, this.project.id, this.deletekey, true, 1).subscribe(
        data => {
          console.log(' getting keys to be deleted ');
          let deleteCount = 0;
          let x2js = new X2JS();
          let objectListForProjectID = x2js.xml_str2json(data);
          if (objectListForProjectID.ListBucketResult.Contents instanceof Array) {
            this.listOfObjectInBucket = objectListForProjectID.ListBucketResult.Contents;
          } else {
            this.listOfObjectInBucket[0] = objectListForProjectID.ListBucketResult.Contents;
          }
          let mapS3objArray = this._ProjectsInfoService.parseAttachmentDataToFolder(this.listOfObjectInBucket);
          for (let i = 0; i < mapS3objArray.length; i++) {
            this._ProjectsInfoService.DeleteProjectAttachmentFile(this.tenanturl, this.deletekey, true, mapS3objArray[i].key)
              .subscribe(
              data => {
                deleteCount++;
                console.log('Deleted S3 object : ', data);

                let breadcrumbString = this._ProjectsInfoService.getCurrentBreadcrumbPath();
                let bcarray = breadcrumbString.split('/');
                let currentFolder = 'Attachments';
                for (let i = 0; i < bcarray.length; i++) {
                  if (i > 0) {
                    currentFolder = bcarray[i - 1];
                  }
                }
                if (mapS3objArray.length == deleteCount) {
                  Materialize.toast(deleteCount + ' files removed', 3000);
                  this.changeAttachmentDirectory(currentFolder, false, 1);
                }
              },
              error => {
              });
          }
        },
        error => {

        }
      );
    }
  }

  downloadAttachmentFile(downloadkey: string, index) {
    document.getElementById('downlaod' + index).click();
  }

  calculateStarRating(rating) {
    this.filledstar = Math.floor(rating / 1);
    this.halfstar = rating % 1;
    if (this.halfstar) {
      this.halfstar = 1;
    }
    this.emptystar = Math.floor(5 - rating);

    this.recipe.filledstar = this.filledstar;
    this.recipe.halfstar = this.halfstar;
    this.recipe.emptystar = this.emptystar;
  }

  createRange(number) {
    let items: number[] = [];
    for (let i = 1; i <= number; i++) {
      items.push(i);
    }
    return items;
  }

  editProjectInfoTable(index) {
    document.getElementById('name' + index).style.display = 'none';
    document.getElementById('nameEdit' + index).style.display = 'block';

    document.getElementById('number' + index).style.display = 'none';
    document.getElementById('numberEdit' + index).style.display = 'block';

    document.getElementById('revision' + index).style.display = 'none';
    document.getElementById('revisionEdit' + index).style.display = 'block';

    document.getElementById('description' + index).style.display = 'none';
    document.getElementById('descriptionEdit' + index).style.display = 'block';

    document.getElementById('owner' + index).style.display = 'none';
    document.getElementById('ownerEdit' + index).style.display = 'block';

    document.getElementById('customername' + index).style.display = 'none';
    document.getElementById('customernameEdit' + index).style.display = 'block';

    document.getElementById('status' + index).style.display = 'none';
    document.getElementById('statusEdit' + index).style.display = 'block';

    this.ownerselect = this.project.assigned_id;
    this.customerselect = this.project.customer_id;
    this.statusselect = this.project.status_id;

    document.getElementById(index + 'projectInfoEdit').style.display = 'none';
    document.getElementById(index + 'projectInfoSave').style.display = 'inline-block';
    document.getElementById(index + 'projectInfoCancel').style.display = 'inline-block';
  }

  saveProjectInfoTable(index) {

    document.getElementById('name' + index).style.display = 'block';
    document.getElementById('nameEdit' + index).style.display = 'none';
    this.project.name = (<HTMLInputElement>document.getElementById('nameEdit' + index)).value;

    document.getElementById('number' + index).style.display = 'block';
    document.getElementById('numberEdit' + index).style.display = 'none';
    this.project.number = (<HTMLInputElement>document.getElementById('numberEdit' + index)).value;

    document.getElementById('revision' + index).style.display = 'block';
    document.getElementById('revisionEdit' + index).style.display = 'none';
    this.project.revision = (<HTMLInputElement>document.getElementById('revisionEdit' + index)).value;

    document.getElementById('description' + index).style.display = 'block';
    document.getElementById('descriptionEdit' + index).style.display = 'none';
    this.project.description = (<HTMLInputElement>document.getElementById('descriptionEdit' + index)).value;

    document.getElementById('owner' + index).style.display = 'block';
    document.getElementById('ownerEdit' + index).style.display = 'none';
    this.project.assigned_id = Number(this.ownerselect);

    document.getElementById('customername' + index).style.display = 'block';
    document.getElementById('customernameEdit' + index).style.display = 'none';
    this.project.customer_id = Number(this.customerselect);

    document.getElementById('status' + index).style.display = 'block';
    document.getElementById('statusEdit' + index).style.display = 'none';
    // this.project.status = Number(this.statusselect);
    this.project.status = this.statusselect;

    document.getElementById(index + 'projectInfoEdit').style.display = 'none';
    document.getElementById(index + 'projectInfoSave').style.display = 'none';
    document.getElementById(index + 'projectInfoCancel').style.display = 'none';
    document.getElementById(index + 'projectInfoSpinner').style.display = 'block';

    // To implement a code to get their actual ids by collecting arrays in dictionary objects

    let updateProjectdetails = {
      name: this.project.name,
      number: this.project.number,
      revision: this.project.revision,
      description: this.project.description,
      assigned_id: this.project.assigned_id,
      customer_id: this.project.customer_id,
      status: this.project.status
    };

    // Update the project properties
    this.projectsService.updateProject(this.project.id, updateProjectdetails)
      .subscribe(
      data => {
        console.log('PROJECT INFO UPDATED SUCCESSFULLY', data);
        Materialize.toast('PROJECT INFO UPDATED SUCCESSFULLY.', 1500);
        this._projectDataService.setForceUpdateBool(true);
        // set back the icon displays
        document.getElementById(index + 'projectInfoEdit').style.display = 'block';
        document.getElementById(index + 'projectInfoSave').style.display = 'none';
        document.getElementById(index + 'projectInfoCancel').style.display = 'none';
        document.getElementById(index + 'projectInfoSpinner').style.display = 'none';
      },
      error => {
        this.errorMessage = <any>error;
        console.error('getProjects() error:', this.errorMessage);
        Materialize.toast('ERROR UPDATING PROJECT INFO, PLEASE TRY AGAIN.', 1500);
      });



  }

  cancelProjectInfoTable(index) {
    document.getElementById('name' + index).style.display = 'block';
    document.getElementById('nameEdit' + index).style.display = 'none';

    document.getElementById('number' + index).style.display = 'block';
    document.getElementById('numberEdit' + index).style.display = 'none';

    document.getElementById('revision' + index).style.display = 'block';
    document.getElementById('revisionEdit' + index).style.display = 'none';

    document.getElementById('description' + index).style.display = 'block';
    document.getElementById('descriptionEdit' + index).style.display = 'none';

    document.getElementById('owner' + index).style.display = 'block';
    document.getElementById('ownerEdit' + index).style.display = 'none';

    document.getElementById('customername' + index).style.display = 'block';
    document.getElementById('customernameEdit' + index).style.display = 'none';

    document.getElementById('status' + index).style.display = 'block';
    document.getElementById('statusEdit' + index).style.display = 'none';

    document.getElementById(index + 'projectInfoEdit').style.display = 'block';
    document.getElementById(index + 'projectInfoSave').style.display = 'none';
    document.getElementById(index + 'projectInfoCancel').style.display = 'none';
    document.getElementById(index + 'projectInfoSpinner').style.display = 'none';

  }

  backToProject() {
    window.history.back();
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/projectinfo/projectinfo.component.ts